import React from 'react';
import { addDays } from 'date-fns';
import { useDispatch } from 'react-redux';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import { ButtonType, ModalWindowTypes } from '../../../utils/@globalTypes';
import ModalWindow from '../ModalWindow';
import {
  BookingFormType,
  FormClosureObjectType,
  UpdateClosureObjectType,
} from '../../../redux/types/bookingTypes';
import useValidationSchema from './validationSchema';
import { Form, Formik } from 'formik';
import ScrollToError from '../../Booking/ScrollToError';
import ClosureObjectHeader from '../../ClosureObjectComponents/ClosureObjectHeader';
import ClosureObjectMain from '../../ClosureObjectComponents/ClosureObjectMain';
import { formatDate } from '../../Booking/functions';
import { createClosureObject } from '../../../redux/reducers/bookingSlice';

import styles from './NewServiceTimeWindow.module.scss';
import Button from '../../Button';

const NewServiceTimeWindow = () => {
  const validationSchema = useValidationSchema();

  const initialValues: FormClosureObjectType = {
    rental_object: undefined,
    start_closure: new Date(),
    end_closure: addDays(new Date(), 1),
    reason: '',
  };
  const dispatch = useDispatch();
  const close = () => {
    dispatch(setModalWindowData({ type: ModalWindowTypes.CLOSE }));
  };

  return (
    <ModalWindow
      isLoading={false}
      isFullCustom
      hideCross
      windowClassname={styles.window}
      isCloseOnOverlay={false}
    >
      <div className={styles.formContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          validateOnMount={false}
          onSubmit={(values) => {
            // console.log(values)
            const newClosureObject: UpdateClosureObjectType = {
              rental_object: values.rental_object,
              start_closure: formatDate(values.start_closure),
              end_closure: formatDate(values.end_closure),
              reason: values.reason,
            };
            try {
              dispatch(createClosureObject(newClosureObject));
            } catch (error) {
              console.error('Ошибка отправки:', error);
            }
          }}
        >
          {(formik) => (
            <Form>
              <ClosureObjectHeader
                windowType={BookingFormType.new}
                formik={formik}
                windowClose={close}
              />
              <ScrollToError />
              <main className={styles.mainContainer}>
                <ClosureObjectMain
                  windowType={BookingFormType.new}
                  formik={formik}
                />
                <div className={styles.btnSave}>
                  <Button
                    title="Сохранить"
                    disabled={!formik.dirty}
                    type={ButtonType.PRIMARY_SMALL}
                    actionType="submit"
                  />
                </div>
              </main>
            </Form>
          )}
        </Formik>
      </div>
    </ModalWindow>
  );
};

export default NewServiceTimeWindow;
